/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Escrow_And_Payout_ManagementInputs */

const en_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrow & Payout Management`)
};

const es_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de custodia y pagos`)
};

const fr_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des Entiercements et Paiements`)
};

const de_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treuhand- & Auszahlungsmanagement`)
};

const ja_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エスクロー＆支払い管理`)
};

const zh_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`担保交易与提现管理`)
};

const ar_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة نظام الضمان (Escrow) والمدفوعات`)
};

const id_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manajemen Escrow & Pembayaran`)
};

const it_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione dell'Escrow & dei Pagamenti`)
};

const ru_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление эскроу-счетами и выплатами`)
};

const pt_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão de Escrow (Garantia) e Pagamentos`)
};

const ko_escrow_and_payout_management = /** @type {(inputs: Escrow_And_Payout_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에스크로 및 정산 관리`)
};

/**
* | output |
* | --- |
* | "Escrow & Payout Management" |
*
* @param {Escrow_And_Payout_ManagementInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const escrow_and_payout_management = /** @type {((inputs?: Escrow_And_Payout_ManagementInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Escrow_And_Payout_ManagementInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_escrow_and_payout_management(inputs)
	if (locale === "es") return es_escrow_and_payout_management(inputs)
	if (locale === "fr") return fr_escrow_and_payout_management(inputs)
	if (locale === "de") return de_escrow_and_payout_management(inputs)
	if (locale === "ja") return ja_escrow_and_payout_management(inputs)
	if (locale === "zh") return zh_escrow_and_payout_management(inputs)
	if (locale === "ar") return ar_escrow_and_payout_management(inputs)
	if (locale === "id") return id_escrow_and_payout_management(inputs)
	if (locale === "it") return it_escrow_and_payout_management(inputs)
	if (locale === "ru") return ru_escrow_and_payout_management(inputs)
	if (locale === "pt") return pt_escrow_and_payout_management(inputs)
	return ko_escrow_and_payout_management(inputs)
});